import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard/locating/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/locating/$canvasId',
      params: { canvasId: 'summary' },
    });
  },
});
